<template>
  <div>
    <div v-if="step == 0" class="choose-storage-type">
        <p class="title">Choose your storage type</p>
        <div class="row">
          <div class="col-md-6">
            <div class="storage-type" @click="setStorageType('roof')">
              <p>Roof</p>
              <img class="colourful" src="https://assets.rhinorack.com/Images/Other/roof-icon.png" alt="roof icon">
              <img class="white" src="https://assets.rhinorack.com/Images/Other/roof-icon-white.png" alt="roof icon">
            </div>
          </div>
          <div class="col-md-6">
            <div class="storage-type" @click="setStorageType('truck-bed')">
              <p>{{ label_truck_bed }}</p>
              <img class="colourful" src="https://assets.rhinorack.com/Images/Other/truck-bed-icon.png" alt="truck bed icon">
              <img class="white" src="https://assets.rhinorack.com/Images/Other/truck-bed-icon-white.png" alt="truck bed icon">
            </div>
          </div>
        </div>
    </div>
    <div v-if="step == 1">
      <label>{{ label_select_vehicle_label }}</label>
      <VehicleDropDown
        :for_load_calc="true"
        v-on:selectVehicleLoadrating="selectVehicleLoadrating($event)"
        :label_manufacturer="label_manufacturer"
        :label_model="label_model"
        :label_year="label_year"
        :label_body_type="label_body_type"
        :label_loading="label_loading"
        :label_select="label_select"
        :label_select_vehicle="label_next"
        :vehicle_type_id="vehicleTypeId"
      ></VehicleDropDown>
    </div>
    <div class="solutions __vehicles" v-if="selectedVehicle && (step == 2)">
      <div class="vehicles">
        <div class="vehicle-drilldown">
          <div class="form">
            <div class="form-content">
              <div class='calculator_summary'>
                <h3 v-if="selectedVehicle" style="font-weight: 700; padding-bottom: 12px;">{{ label_selected_vehicle.toUpperCase() }}</h3>
                <div v-if="selectedVehicle" style="font-weight: 700; padding-bottom: 20px;"> {{ selectedVehicle.full_name }}</div>
              </div>
              <!-- Ref 01 -->
              <div class="form-row" v-if="isTruckBedMode">
                <div>
                  <label>{{ label_stockcode }}</label>
                  <select :disabled="((!vehicleLoadRating) || (vehicleLoadRating <= 0)) && isRoofMode" name id v-model="selectedProduct" @change="refreshTheResults">
                    <option v-for="(vehicleRoofRack, index) in vehicleRoofRacks" :key="index" :value="vehicleRoofRack.productId" :stock-code="vehicleRoofRack.stockCode">
                    {{ vehicleRoofRack.stockCode }} - {{ vehicleRoofRack.title }}</option>
                  </select>
                  <div v-if="showNoFitmentAvailable" class="error">{{ label_no_fitment_available  }}</div>
                </div>
              </div>
              <!-- /Ref 01 -->
              <div class="form-row" v-if="isTruckBedMode">
                <label> {{ label_rhino_rack_system_load_limit }} </label>
                  <input type="number" :value="selectedProductLoadRatingLimit" readonly />
              </div>
              <div class="form-row" v-if="isRoofMode">
                <label v-if="isRoofMode">{{ symbol_weight_unit === 'lbs' ? label_vehicle_load_rating_us : label_vehicle_load_rating }}</label>
                <input type="number" v-model.trim="vehicleLoadRating" />
              </div>
              <div class="form-row" v-if="isTruckBedMode">
                <label v-if="isTruckBedMode">{{ label_load_rating_truck_bed }}</label>
                <input type="number" v-model.trim="ownerManualVehicleLoadRating" />
              </div>
              <!-- Ref 01 - same as the top one for the truck bed mode - just for form order -->
              <div class="form-row" v-if="isRoofMode">
                <div>
                  <label>{{ label_stockcode }}</label>
                  <select :disabled="((!vehicleLoadRating) || (vehicleLoadRating <= 0)) && isRoofMode" name id v-model="selectedProduct" @change="refreshTheResults">
                    <option v-for="(vehicleRoofRack, index) in vehicleRoofRacks" :key="index" :value="vehicleRoofRack.productId" :stock-code="vehicleRoofRack.stockCode">
                    {{ vehicleRoofRack.stockCode }} - {{ vehicleRoofRack.title }}</option>
                  </select>
                  <div v-if="showNoFitmentAvailable" class="error">{{ label_no_fitment_available  }}</div>
                </div>
              </div>
              <div class="form-row">
                <button
                :disabled="(!selectedProduct) || ( isRoofMode && !vehicleLoadRating && vehicleLoadRating <= 0)"
                class="btn btn-hover btn-primary"
                @click="fetchRating()"
                type="button"
                >{{ label_calculate }}</button>
                <button
                class="btn btn-hover btn-primary"
                @click="selectedProduct = null; step--; apiLoadrating = null; apiLoaded = null; vehicleLoadRating = null;"
                type="button"
                >{{ label_back }}</button>
              </div>
              <div class="form-row" v-show="apiLoaded">
                <hr>
                <div style="font-weight: 700; padding: 12px 0px;">{{ label_result }}</div>
                <div v-if="!apiSuccess" class="label_no_product_vehicle_match">{{ label_no_product_vehicle_match  }}</div>
                <div v-if="apiSuccess && apiLoadrating" class="label_product_vehicle_match">
                  <div v-if="apiLoadrating.loadRating > 0">{{ label_dynamic_load_rating }}: <b>{{ Math.floor(apiLoadrating.loadRating * unitConvertor) }}{{ symbol_weight_unit }}</b> </div>
                  <div v-if="apiLoadrating.staticLoadRating > 0">{{ label_static_load_rating }}: <b>{{ Math.floor(apiLoadrating.staticLoadRating * unitConvertor) }}{{ symbol_weight_unit }}</b> </div>

                  <div v-if="isRoofMode">
                    <div v-if="selectedProductObj && (selectedProductObj.weight > 0)">{{ label_system_weight }}: <b>{{ Math.ceil(selectedProductObj.weight * unitConvertor) }}{{ symbol_weight_unit }}</b></div>
                    <div v-if="apiLoadrating.loadRating > 0">{{ label_payload_capacity }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }}</b></div>
                  </div>

                  <div v-if="isTruckBedMode">
                      <div v-if="selectedProductObj && (selectedProductObj.weight > 0)">{{ label_system_weight_truck_bed }}: <b>{{ Math.ceil(selectedProductObj.weight * unitConvertor) }}{{ symbol_weight_unit }}</b></div>
                      <div v-if="apiLoadrating.loadRating > 0">{{ label_payload_capacity_truck_bed }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }}</b></div>
                  </div>

                  <div v-if="apiLoadrating.offroadLoadRating > 0 && apiLoadrating.offroadLoadRating !== -1">{{ label_offroad_load_rating }}: <b>{{ Math.floor(roofRackCargoCapacity / apiLoadrating.offroadLoadRating) }}{{ symbol_weight_unit }}</b></div>
                  <div v-if="apiLoadrating.offroadLoadRating == 0  && apiLoadrating.offroadLoadRating !== -1">{{ label_offroad_load_rating }}: <b>{{ (apiLoadrating.loadRating - selectedProductObj.weight) > 0 ? Math.floor((apiLoadrating.loadRating - selectedProductObj.weight) * unitConvertor) : 0 }}{{ symbol_weight_unit }} {{ isRoofMode ? label_offroad_load_reduction_does_not_apply : label_offroad_load_reduction_does_not_apply_truck_bed }}</b></div>
                  <!-- <div v-if="apiLoadrating.offroadConsiderations">{{ label_offroad_considerations }}: {{ apiLoadrating.offroadConsiderations}}</div> -->
                  <!-- <div>{{ label_special_note }}</div> -->
                  <div><br/>
                    <span v-if="isRoofMode" v-html="load_rating_disclaimer"></span>
                    <span v-if="isTruckBedMode" v-html="load_rating_disclaimer_truck_bed"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VehicleDropDown from "./form-wizard-vehicle.vue";

  export default {
    name: "load-rating-calculator",
    components: {
      VehicleDropDown,
      VehicleDropDown: VehicleDropDown
    },
    data() {
      return {
        vehicleId: null,
        productId: null,
        vehicleLoadRating: null,
        ownerManualVehicleLoadRating: null,
        selectedProduct: null,
        vehicleRoofRacks: [],
        showNoFitmentAvailable: false,
        selectedVehicle: null,
        step: 0,
        apiUrl: `api/calculate-loadrating`,
        apiVehicleProducts: `api/vehicle/products/`,
        apiLoaded: false,
        apiSuccess: false,
        apiLoadrating: null,
        unitConvertor: 1,
        storageType: null,
      };
    },
    props: {
      label_special_note: {
        type: String,
        default: "Special Note: Off-Road Load Rating, if applicable for your system, can be calculated by using the formula provided in your Rhino-Rack fitting instruction.",
      },
      label_result: {
        type: String,
        default: "Result"
      },
      label_manufacturer: {
        type: String,
        default: "Manufacturer",
      },
      label_model: {
        type: String,
        default: "Model",
      },
      label_year: {
        type: String,
        default: "Year",
      },
      label_body_type: {
        type: String,
        default: "Body Type",
      },
      label_loading: {
        type: String,
        default: "Loading",
      },
      label_next: {
        type: String,
        default: "Next",
      },
      label_calculate: {
        type: String,
        default: "Calculate",
      },
      label_back: {
        type: String,
        default: "Back",
      },
      label_select: {
        type: String,
        default: "Select",
      },
      label_select_vehicle_label: {
        type: String,
        default: "Select Vehicle",
      },
      label_select_vehicle: {
        type: String,
        default: "Select Vehicle & next",
      },
      label_stockcode: {
        type: String,
        default: "Please select your Rhino-Rack System:",
      },
      label_vehicle_load_rating: {
        type: String,
        default:
        "Enter your specified vehicle roof loading in kilograms (Kgs) as stated in your vehicle’s owner’s manual:",
      },
      label_vehicle_load_rating_us: {
        type: String,
        default:
        "Enter your specified vehicle roof loading in pounds (lbs) as stated in your vehicle’s owner’s manual:",
      },
      label_no_product_vehicle_match: {
        type: String,
        default: "We dont have a match for that vehicle/product",
      },
      label_no_fitment_available: {
        type: String,
        default: "We do not currently have a fitment available for this vehicle",
      },
      label_dynamic_load_rating: {
        type: String,
        default: "Vehicle/System Load Limit",
      },
      label_static_load_rating: {
        type: String,
        default: "Static load rating",
      },
      label_offroad_load_rating: {
        type: String,
        default: "Off-Road Load Rating (excludes additional accessories)",
      },
      label_offroad_considerations: {
        type: String,
        default: "Off road considerations",
      },
      label_selected_vehicle: {
        type: String,
        default: "Selected Vehicle",
      },
      label_vehicle_loadrating: {
        type: String,
        default: "Your vehicle's load rating",
      },
      label_selected_product: {
        type: String,
        default: "Selected Product",
      },
      symbol_weight_unit: {
        type: String,
        default: "kg",
      },
      load_rating_disclaimer: {
        type: String,
        default: "",
      },
      load_rating_disclaimer_truck_bed: {
        type: String,
        default: "",
      },
      label_payload_capacity: {
        type: String,
        default: "Roof Rack Cargo Capacity (excludes additional accessories)",
      },
      label_system_weight: {
        type: String,
        default: "Roof Rack System Weight (excludes additional accessories)",
      },
      label_offroad_load_reduction_does_not_apply: {
        type: String,
        default: "(off-road load reduction does not apply to this roof rack system.)"
      },
      label_offroad_load_reduction_does_not_apply_truck_bed: {
        type: String,
        default: "(off-road load reduction does not apply to this truck bed system.)"
      },
      label_load_rating_truck_bed: {
        type: String,
        default: "Enter your truck bed load rating in pounds (lbs) as stated in your vehicle's owner’s manual, or by the vehicle manufacturer:"
      },
      label_system_weight_truck_bed: {
        type: String,
        default: "Truck Bed System Weight (excludes additional accessories)",
      },
      label_payload_capacity_truck_bed: {
        type: String,
        default: "Truck Bed Cargo Capacity (excludes additional accessories)",
      },
      label_rhino_rack_system_load_limit: {
        type: String,
        default: 'Rhino-Rack System load limit (lbs):'
      },
      label_truck_bed: {
        type: String,
        default: 'Truck Bed',
      },
      enable_multiple_storage_type: {
        type: String,
        default: 0
      }
    },
    computed:{
     selectedProductObj() {
      return this.vehicleRoofRacks.find(x => x.productId === this.selectedProduct);
    },
    roofRackCargoCapacity() {
      return Math.floor((this.apiLoadrating.loadRating - this.selectedProductObj.weight) * this.unitConvertor)
    },
    isTruckBedMode() {
      return this.storageType == 'truck-bed';
    },
    isRoofMode() {
      return this.storageType == 'roof';
    },
    selectedProductLoadRatingLimit() {
      return this.selectedProductObj ? this.selectedProductObj.loadRatingLimit  : '';
    },
    vehicleTypeId() {
      if(this.isTruckBedMode) {
        return 4; // truck bed vehicle type id
      }
      return null;
    },
  },
  mounted() {
    if(this.enable_multiple_storage_type == 0) {
      this.setStorageType('roof');
    }

    if(this.symbol_weight_unit === 'lbs') {
      this.unitConvertor = 1;
    }
  },
  methods: {
    refreshTheResults(event) {
      this.apiLoaded = false;
      // this.fetchRating();
      this.triggerGA(event);
    },
    triggerGA(event) {
      let selectedProductStockCode = event.target.options[event.target.selectedIndex].getAttribute('stock-code');
      ga('send', 'event', 'Load Rating Calulator','Vehicle Load Rating', this.vehicleLoadRating );
      ga('send', 'event', 'Load Rating Calulator','Rhino-Rack System', selectedProductStockCode );
      gtag('event', 'load_rating_calculator', {'category':'Load Rating Calulator', 'action':'Vehicle Load Rating', 'value': this.vehicleLoadRating});
      gtag('event', 'load_rating_calculator', {'category':'Load Rating Calulator', 'action':'Rhino-Rack System', 'value': selectedProductStockCode});
    },
    fetchVehicleRoofracks() {
      this.showNoFitmentAvailable= false

      axios
      .get(
        this.apiVehicleProducts + this.selectedVehicle.vehicleId + '/true'
        )
      .then((response) => {
        console.log(response.data.data);
        if(!response.data.data.length){
          this.showNoFitmentAvailable= true
        }else{
          this.vehicleRoofRacks = response.data.data;
        }
      });
    },
    fetchRating() {
      if(this.isTruckBedMode) {
        this.setTruckBedLoadRatingValue();
      }
      axios
      .get(
        this.apiUrl +
        "?vehicleId=" +
        this.vehicleId +
        "&productId=" +
        this.selectedProduct +
        "&vehicleLoadRating=" +
        //Math.floor(this.vehicleLoadRating / this.unitConvertor)
        this.vehicleLoadRating
        )
      .then((response) => {
            // console.log('fetching rating', response.data.data);
            this.apiLoadrating = response.data.data;
            this.apiSuccess = response.data.success;
            this.apiLoaded = true;
          });
    },
    selectVehicleLoadrating(data) {
      // here goes the data from vehicle dropdown select
      if (data.data.vehicle && data.data.vehicle.vehicleId) {
        this.vehicleId = data.data.vehicle.vehicleId;
        this.selectedVehicle = data.data.vehicle;
        this.step++;
        this.fetchVehicleRoofracks();
      }
    },
    productSelected(data) {
      if (data.productId) {
        this.productId = data.productId;
        this.selectedProduct = data;
      }
    },
    setStorageType(type) {
      this.storageType = type;
      this.step = 1;
    },
    setTruckBedLoadRatingValue() {
      if (this.ownerManualVehicleLoadRating && this.ownerManualVehicleLoadRating >= 0) {
        this.vehicleLoadRating = this.ownerManualVehicleLoadRating;
      } else {
        this.vehicleLoadRating = this.selectedProductLoadRatingLimit;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.choose-storage-type {
  font-family: 'trim-medium';
  p.title {
    text-transform:uppercase;
    color:#005cb9;
    font-size:2rem;
    text-align:center;
    @media screen and (max-width: 768px) {
       font-size: 1.5rem;
      }
  }
  .storage-type {
    position: relative;
    color: #898989;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem 1rem 0 1rem;
    padding: 25%;
    background-color: white;
    border-radius: 30px;
    font-weight: bolder;
    text-transform: uppercase;
    @media screen and (min-width: 768px) and (max-width: 992px) {
      padding: 30%;
    }
    p {
      position: absolute;
      top: 5rem;
      @media screen and (min-width: 768px) and (max-width: 992px) {
        top: 3rem;
      }
      @media screen and (max-width: 576px) {
        top: 2rem;
      }
    }
    img.colourful {
      display: block;
    }
    img.white {
      display: none;
    }
    &:hover {
      transition: all ease .5s;
      background-color: #005cb9;
      color: white;
      img.colourful {
      display: none;
      }
      img.white {
        display: block;
      }
    }
  }
}
</style>
